import { ChangeDetectionStrategy, Component, inject, model } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { ClarityModule } from '@clr/angular';
import { Table } from 'src/app/models/ui/table';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { TablePrettyPrintPipe } from 'src/app/pipes/tablePrettyPrint.pipe';
import { APIService } from 'src/app/services/APIService/api.service';

@Component({
  selector: 'app-mangel-log-modal',
  templateUrl: './mangel-log-modal.component.html',
  styleUrls: ['./mangel-log-modal.component.scss'],
  imports: [ClarityModule, MrTranslatePipe, TablePrettyPrintPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MangelLogModalComponent {
  private readonly apiService = inject(APIService);
  public readonly omazsid = model.required<number | null>();

  private readonly logResource = rxResource<Table<LogEintrag>, number>({
    params: this.omazsid,
    stream: ({ params }) => this.apiService.getMaengelLog(params),
  });

  protected readonly log = this.logResource.value.asReadonly();
}

export interface LogEintrag {
  LogTyp: string;
  AuftragNr: number;
  UserName: string;
  Status: string;
}
